<template>
  <div id="app">
    <Header :text="headerText" :to="headerPath" />
    <router-view class="router-view"></router-view>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer/Footer.vue";
export default {
  components: { Header, Footer },
  data() {
    return {
      headerText: "Выбрать тур",
      headerPath: "/catalog",
    };
  },
  watch: {
    $route(to) {
      if (to.name === "CatalogPage") {
        this.headerText = "Написать в Telegram";
        this.headerPath = this.$links.telegramManager;
      } else if (to.name === "HomePage") {
        this.headerText = "Выбрать тур";
        this.headerPath = "/catalog";
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: inherit;
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Минимальная высота равна высоте окна браузера */

  /* Добавляем SVG как фоновое изображение */
  background: url("@/assets/svg/noice.svg") repeat center center fixed;
  background-size: contain; /* Масштабирует изображение, чтобы оно покрыло весь экран */
}
</style>
